// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2M84Y","search":"Settings_search__1pXRA","filter":"Settings_filter__2FWW5"};